import React from 'react';
import { HeaderContainer } from '../../../common/sharedStyledComponents/GenericStyles.styled';
import { AppHeader } from '../../../common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { BoostersContainer, BoostersContent } from '../Boosters.styled';
import LearningHubCard from '../../../../components/Learning/LearningHubCard';
import { AllowedDepartment } from '../../../@types/boosters';

export function Boosters () {
  const { t } = useTranslation();

  const boostersCards = [
    {
      id: 11,
      title: t('COMMON.LEARNING.TITLES.FOOD_AND_BEVERAGE'),
      subtitle: t('COMMON.LEARNING.SUBTITLES.CHECK_YOUR_BOOSTERS'),
      media: '/assets/img/boosters_food_and_beverage.png',
      navigate: '/learning/myBooster',
      state: {
        department: AllowedDepartment.FOOD_BEVERAGE,
      },
    },
    {
      id: 12,
      title: t('COMMON.LEARNING.TITLES.FRONT_OF_HOUSE'),
      subtitle: t('COMMON.LEARNING.SUBTITLES.CHECK_YOUR_BOOSTERS'),
      media: '/assets/img/boosters_front_of_house.png',
      navigate: '/learning/myBooster',
      state: {
        department: AllowedDepartment.FRONT_OF_HOUSE,
      },
    },
    {
      id: 13,
      title: t('COMMON.LEARNING.TITLES.HOUSEKEEPING'),
      subtitle: t('COMMON.LEARNING.SUBTITLES.CHECK_YOUR_BOOSTERS'),
      media: '/assets/img/boosters_housekeeping.png',
      navigate: '/learning/myBooster',
      state: {
        department: AllowedDepartment.HOUSEKEEPING,
      },
    },
  ];

  return (
    <>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.LEARNING.TITLES.BOOSTERS')}
          navigateTo="/learning"
        />
      </HeaderContainer>
      <BoostersContainer>
        <BoostersContent>
          {boostersCards.map((element) => (
            <LearningHubCard key={element.id} itemData={element} />
          ))}
        </BoostersContent>
      </BoostersContainer>
    </>
  );
}
